var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Drag and drop to re-order'),expression:"'Drag and drop to re-order'"}],staticClass:"drag drag-handle"},[_c('i',{staticClass:"fa fa-sort"})])
}
var staticRenderFns = []

export { render, staticRenderFns }